'use strict';

angular.module('msLegacyActivities', ['msUtility', 'msCore', 'msWidgets']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('activities', {
    templateUrl: 'legacyActivities/pages/activities.html',
    abstract: true,
    data: {
      pageTitle: 'pageTitles.activities'
    }
  }).state('activities.allTags', {
    templateUrl: 'legacyActivities/pages/activity-rows.html',
    url: '/activities',
    controller: 'ActivityListCtrl'
  }).state('activities.byTag', {
    url: '/activities/:tag',
    templateUrl: 'legacyActivities/pages/activity-list.html',
    controller: 'ActivityLongListCtrl'
  }).state('activitySearchPage', {
    url: '/activities/search/:query',
    params: {
      data: null
    },
    templateUrl: 'legacyActivities/pages/activity-search.html',
    controller: 'ActivitySearchPageCtrl',
    controllerAs: 'vm',
    data: {
      pageTitle: 'pageTitles.search'
    }
  }).state('activityNext', {
    url: '/activity/:activity/next',
    templateUrl: 'legacyActivities/pages/activity-next.html',
    controller: 'ActivityNextCtrl',
    controllerAs: 'next',
    resolve: {
      activity: ['$stateParams', 'activitySvc', function ($stateParams, activitySvc) {
        return activitySvc.getActivity($stateParams.activity);
      }]
    },
    data: {
      pageTitle: 'pageTitles.activitiesNext'
    }
  }).state('activity', {
    url: '/activity/:activity?version',
    templateUrl: 'legacyActivities/pages/activity.html',
    abstract: true,
    controller: 'ActivityCtrl',
    resolve: {
      activity: ['$stateParams', 'activitySvc', function ($stateParams, activitySvc) {
        return activitySvc.getActivity($stateParams.activity, $stateParams.version);
      }]
    },
    data: {
      pageTitle: 'pageTitles.activity'
    }
  }).state('activity.done', {
    url: '/done',
    templateUrl: 'legacyActivities/pages/activity-done.html',
    controller: 'ActivityDoneCtrl',
    controllerAs: 'done',
    data: {
      pageTitle: 'pageTitles.activity'
    }
  }).state('activity.section', {
    url: '',
    templateUrl: 'legacyActivities/pages/section.html',
    controller: 'SectionCtrl',
    params: {
      section: {
        squash: true,
        value: ''
      }
    },
    resolve: {
      section: ['activity', '$stateParams', function (activity, $stateParams) {
        var sectionUuid = $stateParams.section || activity.firstSection;
        var section = activity.sections.filter(function (section) {
          return section.uuid === sectionUuid;
        })[0];
        if (!section) {
          throw Error('Could not find first section');
        }
        return section;
      }]
    }
  }).state('activityResponse', {
    url: '/responses/:response',
    templateUrl: 'legacyActivities/pages/activity-response.html',
    controller: 'ActivityResponseCtrl',
    controllerAs: 'vm',
    resolve: {
      responseId: ['$stateParams', function ($stateParams) {
        return $stateParams.response;
      }],
      activityResponse: ['$stateParams', 'activitySvc', 'httpSvc', function ($stateParams, activitySvc, httpSvc) {
        return httpSvc.get('/apiproxy/user/activities/responses/' + $stateParams.response);
      }],
      status: ['$stateParams', 'activitySvc', function ($stateParams, activitySvc) {
        return activitySvc.getActivityResponseSharedStatus($stateParams.response);
      }]
    }
  });
}]);